import { useEffect, useState, useCallback } from "react";
import { useDeviceType } from "../context/DeviceContext";

export default function useProgress(
  initialInputs: {
    id: number;
    name: string;
    value:
      | string
      | number
      | { depart: string; return?: string | undefined }
      | { adult: number; child: (string | undefined)[] } // Add this type
      | undefined;
  }[],
) {
  const deviceType = useDeviceType();
  const [openStatus, setOpenStatus] = useState(
    initialInputs.map(({ id }) => ({ open: false, id })),
  );

  const [change, setChange] = useState<{
    id: number;
    isValueSet: boolean;
  } | null>(null);

  const handleProgress = useCallback((id: number, isValueSet = false) => {
    setChange({
      id,
      isValueSet,
    });
  }, []);

  useEffect(() => {
    if (change) {
      const { id, isValueSet } = change;
      const nextInputToOpen = initialInputs.findIndex(({ value }) => !value);

      setOpenStatus((prev) =>
        isValueSet && nextInputToOpen !== -1
          ? prev.map((item) =>
              item.id === nextInputToOpen
                ? { ...item, open: !item.open }
                : item,
            )
          : deviceType === "mobile"
            ? prev
            : prev.map((item) =>
                item.id === id ? { ...item, open: !item.open } : item,
              ),
      );
    }
  }, [change]);

  return {
    handleProgress,
    openStatus,
  };
}
